module.exports = __webpack_public_path__ + "static/media/mtga-sprites.aea0d3b3.png";